export const FEEDBACK_CATEGORIES = [
  'Bug',
  'Feature Request',
  'Listing Issue',
  'Billing / Subscription',
  'General Feedback',
] as const;

export type FeedbackCategory = (typeof FEEDBACK_CATEGORIES)[number];
